export default "__VITE_ASSET__IEcDsTW3__"